import { useParams } from 'react-router-dom';
import { createRoute } from 'framework/routing';

export const INTERVIEW_SCHEDULING_PATH = '/interview-scheduling';

export const useInterviewSchedulingRoute = () => {
  const routers = createRoute({ listRoute: INTERVIEW_SCHEDULING_PATH });

  return {
    ...routers,
  };
};

export const useInterviewSchedulingToken = () => {
  const { '*': token } = useParams<Dictionary<string>>();

  return token!;
};
